import { Modal } from "@nulogy/components";
import usePublishWorkBlockModal from "hooks/state/usePublishWorkBlockModal";
import React from "react";
import PublishWorkBlockModalForm from "./PublishWorkBlockModalForm";

export default function PublishWorkBlockModal() {
  const { close: closeModal, isOpen, workBlock } = usePublishWorkBlockModal();

  const close = () => {
    closeModal();
  };

  return (
    <Modal ariaHideApp={false} isOpen={isOpen} maxWidth="816px" onRequestClose={close} title="Publish to job">
      <PublishWorkBlockModalForm workBlock={workBlock} />
    </Modal>
  );
}
